<template>
  <div class="page-container">
    <div class="item-box-430">
      <div class="org-head">
        <div class="box-title-430">添加服务</div>
        <span class="tips">
          <Icon type="md-alert" color="#6348ee"></Icon>
          完成服务创建后可进入详情页面“商户信息”模块完善信息，否则无法创建课班、托管及订餐！
        </span>
        <Button
          class="back-btn"
          type="primary"
          @click="back"
        >返回上一步</Button>
      </div>
      <div class="form-box">
        <Form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="labelWidth"
        >
          <div class="box-title-430-second box-title">
            服务信息
          </div>
          <FormItem label="服务名称:" prop="orgName">
            <Input
              v-model="formValidate.orgName"
              placeholder="请输入服务名称"
              :maxlength="50"
              class="label-width"
              clearable
            ></Input>
            <span style="color:#FF0000;margin-left:30px">需与工商营业执照名称一致,请务必准确填写</span>
          </FormItem>
          <FormItem label="管理员姓名:" prop="operatorName">
            <Input
              v-model="formValidate.operatorName"
              placeholder="请输入管理员姓名"
              :maxlength="8"
              class="label-width"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="手机号码:" prop="operatorPhone">
            <Input
              v-model="formValidate.operatorPhone"
              placeholder="请输入手机号码"
              :maxlength="11"
              class="label-width"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="手机验证码:" prop="msgCode">
            <div class="code-box label-width">
              <Input
                v-model="formValidate.msgCode"
                :maxlength="5"
                placeholder="请输入手机验证码"
                class="flex1"
                clearable
              ></Input>
              <Button
                type="primary"
                :disabled="canClickCodeBtn ? false : true"
                @click="handleGetPhoneCode"
              >{{ getCodeBtnText }}</Button>
            </div>
          </FormItem>
          <FormItem label="管理员用户名:" prop="operatorCode">
            <Input
              v-model="formValidate.operatorCode"
              :maxlength="20"
              placeholder="请输入管理员用户名"
              class="label-width"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="管理员密码:" prop="password">
            <Input
              v-model="formValidate.password"
              :maxlength="100"
              placeholder="密码会覆盖之前的原密码，密码中必须包含大小写字母、数字、特殊字符"
              class="label-width"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="是否启用：" prop="opSts">
            <RadioGroup v-model="formValidate.opSts">
              <Radio label="1">是</Radio>
              <Radio label="2">否</Radio>
            </RadioGroup>
          </FormItem>
        </Form>
        <!-- 校区管理 start  -->
        <div class="table-box box-title-mb-430">
          <div
            class="table-title flex justify-space_between align-items box-title-mb-430"
          >
            <div class="box-title-430-second">
              校区管理
            </div>
            <Button
              class="back"
              type="primary"
              @click="showAddModal"
            >添加校区</Button>
          </div>
          <Table border :columns="branchDataColumn" :data="branchTableData">
            <template slot="action" slot-scope="{ row, index }">
              <span
                style="margin-right: 5px;color:#1C7FFE;cursor: pointer;"
                @click="editBranchTableData(row, index)"
              >编辑</span>
              <span
                style="margin-right: 5px;color:#1C7FFE;cursor: pointer;"
                @click="delBranchRowData(index)"
              >删除</span>
            </template>
          </Table>
        </div>
        <!-- 校区管理 end  -->
      </div>
      <div class="form-bottom">
        <Button type="primary" @click="checkForms">确定</Button>
        <Button type="error" @click="back">取消</Button>
      </div>
    </div>
    <!-- 校区管理-添加校区 -->
    <Modal
      v-model="branchPop"
      :title="branchModalType == 'add' ? '添加校区' : '编辑校区'"
      width="600"
    >
      <div class="page_modal">
        <Form
          ref="branchModalFormValidate"
          :model="branchModalFormValidate"
          :rules="branchModalRuleValidate"
          :label-width="120"
        >
          <FormItem label="校区名称：" prop="branchName">
            <Input
              v-model="branchModalFormValidate.branchName"
              :maxlength="50"
              style="width:300px"
              placeholder="请输入校区名称"
            ></Input>
          </FormItem>
          <FormItem label="校区区域：" prop="areaIdArray">
            <Cascader
              v-model="branchModalFormValidate.areaIdArray"
              :data="regionDataList"
              style="width:300px;margin-right: 10px"
              @on-change="handelAreaValuebranch"
            ></Cascader>
          </FormItem>
          <FormItem label="地址：" prop="address">
            <Input
              v-model="branchModalFormValidate.address"
              :maxlength="100"
              style="width:300px"
              placeholder="请输入校区地址"
            ></Input>
          </FormItem>
          <FormItem label="校区电话：" prop="branchPhone">
            <Input
              v-model="branchModalFormValidate.branchPhone"
              :maxlength="11"
              style="width:300px"
              placeholder="请输入校区电话"
            ></Input>
          </FormItem>
          <FormItem label="校区座机：" prop="branchTellphone">
            <Input
              v-model="branchModalFormValidate.branchTellphone"
              :maxlength="12"
              style="width:300px"
              placeholder="请输入校区座机"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="text" @click="closeModal">取消</Button>
        <Button type="primary" @click="handleBranchData">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { regionDataList } from '@/utils/dictionary';
import {
  branchDataColumn,
  branchModalFormValidate,
  branchModalRuleValidate
} from '../assets/data/data.js';
import { getTodayDate } from '@/utils/moment';
import { checkPasswordRule } from '@/utils/utils';
import common from '@/request/common/index';
import operationAdmin from '@/request/operationAdmin/index';
export default {
  name: 'NewOrgan',
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入管理员密码'));
      } else if (checkPasswordRule(value) == false) {
        callback(
          new Error(
            '您的设置的密码复杂度太低（密码中必须包含大小写字母、数字、特殊字符），请修改密码！'
          )
        );
      } else {
        callback();
      }
    };
    return {
      labelWidth: 150, // 表单左侧宽度
      formItemWidth: 600, // 表单右侧内容宽度
      formValidate: {
        orgName: '', // 服务名称
        operatorName: '', // 管理员姓名
        operatorPhone: '', // 手机号码
        msgCode: '', // 手机验证码
        operatorCode: '', // 管理员用户名
        password: '', // 管理员密码
        opSts: '' // 是否启用
      },
      ruleValidate: {
        orgName: [
          { required: true, message: '请输入服务名称', trigger: 'blur' }
        ],
        operatorName: [
          { required: true, message: '请输入管理员姓名', trigger: 'blur' }
        ],
        operatorPhone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            pattern: /^1[0-9]{10}$/,
            message: '手机号格式不正确！',
            trigger: 'blur'
          }
        ],
        msgCode: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' }
        ],
        operatorCode: [
          { required: true, message: '请输入管理员用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
          // { required: true, message: "请输入管理员密码", trigger: "blur" }
        ],
        opSts: [
          {
            required: true,
            message: '请选择是否启用',
            trigger: 'change'
          }
        ]
      },
      branchDataColumn, // 校区管理
      branchId: 0, // 校区id
      branchTableData: [], // 校区管理表格信息
      getCodeBtnText: '发送验证码', // 发送验证码按钮文案
      countDown: false, // 倒计时是否已启动
      branchPop: false, // 添加校区弹窗
      branchModalType: 'add', // 是添加校区还是修改校区 add 添加 edit 修改
      branchTableSelectIdx: 0, // 选择了table的第几行数据
      // 添加编辑校区的表单参数
      branchModalFormValidate,
      // 添加编辑校区表单验证规则
      branchModalRuleValidate,
      // 区域列表
      regionDataList: [...regionDataList]
    };
  },
  computed: {
    // 是否可以点击发送验证码按钮
    canClickCodeBtn() {
      const reg = /^1[0-9]{10}$/;
      const result = reg.test(this.formValidate.operatorPhone);
      // console.log(result, "结果i");
      return result && !this.countDown;
    }
  },
  methods: {
    // 点击发送验证码按钮
    async handleGetPhoneCode() {
      await this.sendMsg();
      let second = 60;
      this.getCodeBtnText = `${second}s后获取`;
      this.countDown = true;
      this.timer = setInterval(() => {
        if (second == 0) {
          clearInterval(this.timer);
          this.countDown = false;
          this.getCodeBtnText = '获取验证码';
          return false;
        }
        second--;
        this.getCodeBtnText = `${second}s后获取`;
      }, 1000);
    },
    async sendMsg() {
      return new Promise(async resolve => {
        const res = await common.getMsgCode({
          phone: this.formValidate.operatorPhone
        });
        if (res.status == 200) {
          this.$Message.success('发送成功，请注意查收');
          resolve();
        }
      });
    },
    // 点击返回上一步
    back() {
      this.$router.go(-1);
    },
    // 点击展示添加校区弹窗
    showAddModal() {
      this.branchModalType = 'add';
      this.branchPop = true;
    },
    // 关闭添加校区弹窗
    closeModal() {
      this.branchPop = false;
    },
    // 处理要编辑的数据并打开弹窗
    editBranchTableData(row, index) {
      this.branchModalFormValidate = JSON.parse(JSON.stringify(row));
      this.branchTableSelectIdx = index;
      this.branchModalType = 'edit';
      this.branchPop = true;
    },
    // 删除校区数据表格的数据
    delBranchRowData(index) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '您确定要删除该行数据吗？',
        onOk: () => {
          this.branchTableData.splice(index);
        },
        onCancel: () => {
          // this.$Message.info("Clicked cancel");
        }
      });
    },
    // 点击弹窗的确定按钮，处理添加或者编辑校区的数据
    handleBranchData() {
      this.$refs.branchModalFormValidate.validate(valid => {
        const branchTableDataItem = JSON.parse(
          JSON.stringify(this.branchModalFormValidate)
        );
        branchTableDataItem.areaId =
          branchTableDataItem.areaIdArray[
            branchTableDataItem.areaIdArray.length - 1
          ];
        if (valid && this.branchModalType == 'add') {
          // console.log(branchTableDataItem, "是啥-----------111");
          branchTableDataItem.branchId = ++this.branchId;
          branchTableDataItem.createTime = getTodayDate('YYYY-MM-DD HH:mm:ss');
          this.branchTableData.push(branchTableDataItem);
          this.branchPop = false;
          // 添加进列表之后清空表单数据
          this.$refs.branchModalFormValidate.resetFields();
        } else if (valid && this.branchModalType == 'edit') {
          this.branchTableData.splice(
            this.branchTableSelectIdx,
            1,
            branchTableDataItem
          );
          this.branchPop = false;
          // 编辑列表之后清空表单数据
          this.$refs.branchModalFormValidate.resetFields();
        }
      });
    },
    // 处理校区的区域(根据areaid显示文字)
    handelAreaValuebranch(value, selectedData) {
      this.branchModalFormValidate.area = '';
      selectedData.forEach((item, index) => {
        if (index == 0) {
          this.branchModalFormValidate.area += `${item.label}`;
        } else {
          this.branchModalFormValidate.area += `/${item.label}`;
        }
      });
    },
    // 地区选择(获取地区名称)
    handelAreaValue(value, selectedData) {
      this.formValidate.orgArea = '';
      selectedData.forEach((item, index) => {
        if (index == 0) {
          this.formValidate.orgArea += `${item.label}`;
        } else {
          this.formValidate.orgArea += `/${item.label}`;
        }
      });
      // console.log(this[formName], "现在是啥----");
    },
    // 点击确定按钮验证表单
    checkForms() {
      // 没有校区数据的，不提交
      if (this.branchTableData.length == 0) {
        return this.$Message.error('请添加校区');
      }
      // 先验证基础信息表单是否填写完整
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          console.log(valid, '验证表单成功');
          this.submitForm();
        } else {
          console.log(valid, '验证表单失败');
        }
      });
    },
    async addOrg() {
      const params = {
        orgName: this.formValidate.orgName, // 机构名字
        operatorAddBO: {
          operatorTypeEnum: 'ORG_TYPE', //  1:教育局 2：学校 3：机构 4：餐饮机构 5：运营用户 4:机构
          operatorCode: this.formValidate.operatorCode, // 操作员账号
          operatorName: this.formValidate.operatorName, // 操作员姓名
          password: this.formValidate.password, // 登录密码
          operatorRole: 'SYSTEM_ROLE', // 操作员角色  默认管理员
          operatorPhone: this.formValidate.operatorPhone, // 操作员手机号码
          msgCode: this.formValidate.msgCode,
          // orgId: "", // 操作员默认组织id
          opSts: this.formValidate.opSts
        },
        organizationBranches: this.branchTableData // 校区信息---
      };
      const res = await operationAdmin.addOrgV3(params);
      if (res.status == 200) {
        console.log('添加机构成功');
        this.openAskModal(res.message);
      }
    },
    openAskModal(orgId) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>服务创建成功！是否继续完善商户信息？</p>',
        onOk: () => {
          console.log('点击了是，去到完善商户信息页面');
          this.goToMerchantPage(orgId);
        },
        onCancel: () => {
          this.back();
        }
      });
    },
    // 去到商户信息页面
    goToMerchantPage(orgId) {
      this.$router.push({
        name: 'resource_organdetail',
        query: { orgId, active: 2, merchantEdit: 1 }
      });
    },
    // 提交表单信息
    submitForm() {
      this.addOrg();
      // this.$Modal.confirm({
      //   title: "提示",
      //   content: "<p>服务创建成功！是否继续完善商户信息？</p>",
      //   onOk: () => {
      //     console.log("点击了是，去到完善商户信息页面");
      //   },
      //   onCancel: () => {
      //     this.back();
      //   }
      // });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  .org-head {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: 1px solid #ccc;
    .tips {
      color: #6348ee;
      margin-left: 16px;
    }
    .back-btn {
      margin-left: auto;
    }
  }
  .form-box {
    padding-top: 32px;
    .box-title {
      margin-bottom: 64px;
    }
  }
  .label-width {
    width: 600px;
  }
  .form-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    button + button {
      margin-left: 32px;
    }
  }
  .code-box {
    display: flex;
    // border: 1px solid #ccc;
    .flex1 {
      flex: 1;
    }
    /deep/.ivu-input {
      border-right: none;
      border-radius: 4px 0 0 4px;
    }
    /deep/.ivu-btn {
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>
